import { Box, useTheme } from "@mui/material";
import Text from "../theme/text/Text";
import { tokens } from "../../theme";
import TextInput from "../theme/inputs/TextInput";
import ShLabel from "../theme/label/ShLabel";
import { getOrderStateData } from "../../utils/labelColorText";
import { useTranslation } from "react-i18next";
import { general_states } from "../../utils/staticEnums";

const SplitOrderLine = (props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const {t} = useTranslation();

  const onChange =(e) => {
    const value = e.target.value;
    if (value && !isNaN(value)) {
      props.setProducts(props.index,value);
      // setProducts() // change here
    } else {
      props.setProducts(props.index,0);
    }
  }

  const stateData = getOrderStateData(props.product.state, theme);
  
  return (
    <Box
      sx={{
        display:"flex",
        justifyContent:"space-between",
        alignItems:"center",
        background:"white",
        border:"1px solid #ecf0f5",
        boxShadow:"0px 1px 2px rgba(49,65,95,.55)",
        minHeight:56,
        pl:2,
        pr:0.5,
        py:1,
        borderRadius:5,
        width:1,
        maxWidth:600,
      }}
    >
      <Box
        sx={{
          flex:1,
          minWidth:0,
          display: "flex",
          flexDirection: "column",
          gap: 0.25,
          mr: 1
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1
          }}
        >
          <Text
            sx={{
              color: theme.palette.mode === "dark" ? colors.blue[400] : colors.blue[600],
              fontSize: 13,
              fontWeight: 500
            }}
          >
            {props.product.sku}
          </Text>
          {props.product.backorder > 0 &&
            <ShLabel
              clickable
              size={24}
              fitted
              variant="pink"
              palette="normal"
            >
              {props.product.backorder} in {t("backordered")}
            </ShLabel>
          }
          {/* {(props.product.state === general_states.REPLENISH || props.product.state === general_states.BACKORDERED) &&
            <ShLabel
              clickable
              size={24}
              fitted
              variant={stateData.labelcolor}
              palette="normal"
            >
              {t(stateData.labeltext)}
            </ShLabel>
          } */}
        </Box>
        <Text
          sx={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            color: colors.txt["primary"],
            fontSize: 14,
            lineHeight: 1.3
          }}
        >
          {props.product.title}
        </Text>
      </Box>

      <Box
        sx={{
          ml:"auto",
          mr:1,
          px:2,
          lineHeight:"32px",
          borderRadius:4,
          flexShrink: 0
        }}
      >
        <Text>{props.product.currAmount}</Text>
        <Text light>&nbsp;x</Text>
      </Box>

      <TextInput error={props.isError} type="number" onChange={onChange} width={64}/>
    </Box>
  );
};

export default SplitOrderLine;